import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import "./paymentConnection.css";

const DisablePaymentsModal = ({ show, onHide, onConfirm, isLoading }) => (
  <Modal show={show} onHide={onHide} centered className="pc-modal">
    <Modal.Header closeButton>
      <Modal.Title>Disable Payments?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ul className="mb-0 ps-3">
        <li>You won't be able to create new payment requests.</li>
        <li>Your payment account and existing payment requests are not affected.</li>
        <li>You can re-enable at any time.</li>
      </ul>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide} disabled={isLoading}>
        Cancel
      </Button>
      <Button variant="outline-danger" onClick={onConfirm} disabled={isLoading}>
        {isLoading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Disabling...
          </>
        ) : (
          "Disable Payments"
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DisablePaymentsModal;
